import { render, staticRenderFns } from "./AboutUsSchedule.vue?vue&type=template&id=3142999a&lang=html&"
import script from "./AboutUsSchedule.vue?vue&type=script&lang=js&"
export * from "./AboutUsSchedule.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsSchedule.vue?vue&type=style&index=0&id=3142999a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports